import React from 'react'
import { FilterSchema } from '@adc/blueprint'
import InlineSelectField from '../../../formFields/inlineSelectField'

type InlineSelectProps = FilterSchema.FilterLayoutProps<
  FilterSchema.FilterInlineSelectDefinition,
  FilterSchema.InlineSelectValueType
>

const InlineSelect: React.FunctionComponent<InlineSelectProps> = ({
  compact,
  definition,
  value,
  elmId,
  onChange,
}) => {
  const options = definition.options.map(option => ({
    value: option.value,
    text: option.label,
  }))

  const handleChange = (newValue: string | number | (string | number)[]) => {
    let filterValue = null

    if (definition.mode === 'multi') {
      filterValue =
        newValue === '' || (Array.isArray(newValue) && newValue.length === 0)
          ? []
          : (newValue as FilterSchema.InlineSelectControlValueType)
    } else {
      filterValue = newValue || ''
    }

    // @ts-ignore next
    onChange(definition.name, filterValue)
  }

  return (
    <InlineSelectField
      compact={compact}
      fluid
      elmId={`${elmId}_${definition.name}`}
      options={options}
      value={value || ''}
      mode={definition.mode || 'single'}
      onChange={handleChange}
      showAnyOption
      anyOptionText='Any'
      hideWrapper
    />
  )
}

export default InlineSelect
